import { render, staticRenderFns } from "./PeopleAlsoAsked.vue?vue&type=template&id=232ab8b0&"
import script from "./PeopleAlsoAsked.vue?vue&type=script&lang=js&"
export * from "./PeopleAlsoAsked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports